module.exports = __webpack_public_path__ + "img/Spinner-1s-200px.28ff9a52.gif";